import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { checkAuth } from "../utils/authGuard";

interface Props {
  children: React.ReactNode;
}

export default function PublicRoute({ children }: Props) {

  const [isAuth, setIsAuth] = useState<boolean | null>(null);

  useEffect(() => {

    const verify = async () => {
      const result = await checkAuth();
      setIsAuth(result);
    };

    verify();

  }, []);

  if (isAuth === null) return <div>Loading...</div>;

  if (isAuth) return <Navigate to="/home" />;

  return <>{children}</>;
}